$(document).ready(function(){
    // Header menu Fixed 
    $(window).scroll(function () {
        if ($(this).scrollTop() > 40) {
        $(".header_main").addClass("menufixed");
        $("body").addClass("header_fixed");
        $("body").addClass("cart_top");
        } else {
        $(".header_main").removeClass("menufixed");
        $("body").removeClass("header_fixed");
        $("body").removeClass("cart_top"); 
        }
    });

    // Mega menu 
    $('.header__inline-menu a').hover(function() {
        var data = $(this).data('dropdown-rel');
        $('.megamenu').parent('.mega-menu-section').addClass('opacity-0 h-0 invisible'); 
        $('.mega-menu-section').parent('.mega-menu-wrapper').addClass('menu-show');
        $('body').addClass('overflow-hidden'); 
        $('.megamenu[data-dropdown="' + data + '"]').parent('.mega-menu-section').removeClass('opacity-0 h-0 invisible');   
    });
    
    $('.header__inline-menu').mouseleave(function() {
        if($(".mega-menu-section:hover").length == 0){
            $('.megamenu').parent('.mega-menu-section').addClass('opacity-0 h-0 invisible');
            $('.mega-menu-section').parent('.mega-menu-wrapper').removeClass('menu-show'); // Remove menu-show class here
            $('body').removeClass('overflow-hidden'); 
        }
    }).mouseleave();
    
    $('.mega-menu-section').mouseleave(function() {
        $(this).addClass('opacity-0 h-0 invisible'); 
        $(this).parent('.mega-menu-wrapper').removeClass('menu-show'); // Remove menu-show class here
        $('body').removeClass('overflow-hidden');  
    }).mouseleave();
    
    $('.header-dropdown').mouseenter(function() {
        $('.megamenu').parent('.mega-menu-section').addClass('opacity-0 h-0 invisible');
        $('.mega-menu-section').parent('.mega-menu-wrapper').addClass('menu-show');
    });
  });





  
  
  